import { ApiCaller } from 'apis/ApiCaller';
import { Success } from 'types';

export type OrderableLicense = {
	DaysExpire: number;
	Deliverables: LicenseDeliverable[];
	ID: number;
	LicenseType: number;
	MaxUses: string;
	Name: string;
	SuppliedBy: number;
	UsageDays: number;
};

export type LicenseDeliverable = {
	MaxUses: number | null;
	NumSeats: number | null;
	NumUses: number | null;
	Type: number;
};

export type PlaceOrderInventory = {
	Inventory: number;
	LicenseID: number;
};

export type RenewableOrder = {
	DateCreate: string;
	DateExpire: string | null;
	DateStart: string | null;
	ID: number;
	LicenseId: number;
	LicenseName: string;
	NumAvailable: number | null;
	NumRequested: number;
	OrderControl: string;
	RenewedByControl: string | null;
	RenewedByID: number | null;
	RequestedUserFullName: string;
};

export type PlaceOrderRequest = {
	comment: string;
	futureStart: string | null;
	isAutofill: number;
	isOffline: boolean;
	licenseId: number;
	numRequested: number;
	orderIdToAutofill: number | null;
	partnerForId: number;
	purchaseOrder: string;
	renewId: number | null;
	requestingPartner: number;
};

export class PlaceOrderApi {

    private static apiCaller = new ApiCaller('PlaceOrder');

    public static GetOrderableLicenses(requestingPartner: number, showPartner: number): Promise<OrderableLicense[]> {

        return this.apiCaller.GET<OrderableLicense[]>('GetOrderableLicenses', { requestingPartner, showPartner });

    }

    public static GetInventory(partnerId: number): Promise<PlaceOrderInventory[]> {

        return this.apiCaller.GET<PlaceOrderInventory[]>('GetInventory', { partnerId });

    }

    public static GetRenewableOrders(requestingPartner: number, showPartner: number): Promise<RenewableOrder[]> {

        return this.apiCaller.GET<RenewableOrder[]>('GetRenewableOrders', { requestingPartner, showPartner });

    }

    public static PlaceOrder(request: PlaceOrderRequest): Promise<Success<void>> {

        return this.apiCaller.POST<Success<void>>('PlaceOrder', request);

    }

}
